import React from 'react'
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function ConfirmDIalouge({message="Message Here!",desc="Message Description here", action="Action!",actionHandler=()=>{console.log("No Action Handler Passed")}, closeHandler=()=>{console.log("No Close Handler Passed")}}) {
  return (
    <div className="w-screen h-screen fixed backdrop-blur-sm inset-0 z-40">
    <div className='w-11/12 md:w-1/2 lg:w-4/12 bg-white mx-auto rounded-md shadow-md border px-2 pb-6 pt-2 flex flex-col items-center gap-5 fixed inset-0 top-1/4 max-h-fit'>
        <div className="w-full flex justify-end"><button onClick={closeHandler}><CloseIcon/></button></div>
        <WarningAmberIcon sx={{ fontSize: 70, color: 'red' }}/>
        <div>
        <h1 className='text-3xl font-medium text-center'>{message}</h1>
        <p className='w-full md:w-10/12 lg:w-8/12 mx-auto text-center break-words'>{desc}</p>
        </div>
        <div className="w-full flex justify-center gap-6">
            <button onClick={actionHandler} className='p-3 bg-red-400 text-white font-medium rounded-md'>{action}</button>
            <button onClick={closeHandler} className='p-3 bg-gray-400 text-white font-medium rounded-md'>Close</button>
        </div>

    </div>
    </div>
  )
}
